import { Modal } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: documentActions } = createNamespacedHelpers('document')

export default {
  methods: {
    ...documentActions(['bulkArchiveSignedInstances']),

    openBulkArchiveConfirm({ type, object_id, name, onDone }) {
      Modal.confirm({
        title: 'Archive Signed Documents?',
        content: `All signed instances of "${name}" will be archived across all active profiles.`,
        okText: 'Archive',
        cancelText: 'Cancel',
        maskClosable: false,
        onOk: async () => {
          try {
            const archived = await this.bulkArchiveSignedInstances({ type, object_id })

            this.showNotification(
              'success',
              'Success',
              `Archived: ${archived}. The operation is all-or-nothing: either all eligible signed instances are archived, or none are.`
            )

            if (onDone) await onDone()
          } catch (error) {
            this.showNotification(
              'error',
              'Error',
              `${typeof error === 'string' ? error : error?.message} No records were archived.`
            )

            throw error
          }
        },
        onCancel() {}
      })
    }
  }
}
